import React from 'react';
import parse from 'html-react-parser';
import { useInputNumberGroup } from '../hooks';
import InputNumber from 'rsuite/InputNumber';
import OptionSize from '../../OptionElements/OptionSize';
import OptionTitle from '../../OptionElements/OptionTitle';
import OptionDescription from '../../OptionElements/OptionDescription';
import OptionPrice from '../../OptionElements/OptionPrice';
import OptionEta from '../../OptionElements/OptionEta';
import * as Utils from 'utils';

export default function OptionTypeInputNumberSizes(props) {
  const {options} = props;
  const [, onChangeOptions] = useInputNumberGroup(props);

  return (
    <div className="app-option-list">
      {options.map((option, optionIndex) => {
        const {
          id,
          title = '',
          description = '',
          size,
          priceTitle,
          priceIsCustom,
          durationTitle,
          durationValue,
          durationSuffix,
          quantityTitle,
          quantityValue,
          quantityValueMin,
          quantityValueMax,
          customClass = '',
          isDisabled = false
        } = option;

        return (
          <div className={`app-option-item ${customClass}`} key={id}>
            <OptionSize size={size} />
            <div className="app-option-container-description">
              <div className="app-option-container-examples">
                <OptionTitle title={title} />
                <OptionDescription description={description} />
              </div>
              <div className="app-option-container-price">
                <OptionPrice
                    priceTitle={priceTitle}
                    priceValueText={priceIsCustom ? 'Custom' : Utils.replacer(option, 'priceValueText')}
                />
                <OptionEta
                    durationTitle={durationTitle}
                    durationValue={durationValue ? durationValue : ''}
                    durationSuffix={durationSuffix}
                />

              </div>
            </div>
            <div className="app-option-container-quantity">
              {quantityTitle && <div className="app-option-title">{parse(quantityTitle)}</div>}
              <InputNumber
                  value={quantityValue}
                  min={quantityValueMin}
                  max={quantityValueMax}
                  disabled={isDisabled}
                  onChange={(value, event) => onChangeOptions(value, event, optionIndex)}
              />
            </div>

          </div>
        )
      })}
    </div>
  )
}
